module.exports = __webpack_public_path__ + "static/media/popup_close.7a64be8d.svg";